<template>
  <div class="markMGMHome" v-wechat-title="$route.meta.title">
    <div class="w3-row">
      <div class="w3-container">
        <!-- pic & name & level -->
        <div class="w3-row">
          <div class="w3-col s7">
            <div class="w3-col s6">
              <img id="pic" :src="picture">
              <br />
            </div>
            <div id="userProfile" class="w3-col s6">
              <p id="userName">{{ displayname }}</p> <!---->
              <p id="lv">L.V： {{ level }}</p>
            </div>

            <!-- point & share & medal -->
            <div>
              <p>任務點數： {{ point }}</p>
              <p>分享隊員： {{ share }}</p>
              <p>榮譽勳章:</p>
              <img id="medal" src="../assets/medal.png">
              <div>
                <a href="https://line.me/R/ti/p/%40fva0918s"><img id="logo" src="../assets/EILIS_GR.png"></a>
              </div>
            </div>
          </div>
          <!-- button -->
          <div id="btn" class="w3-col s5">
          <br />
            <!--<a :href="'line://msg/text/?一起加入好友%0D%0A%0D%0Aline://app/1557731059-nBZ0827a?c='+this.c+'&rec='+this.userId">-->
            <router-link :to="{name:'markRecommend'}">
              <button id="able">邀請好友</button>
              <!--v-on:click="recommend" :disabled="isDisable"-->
            </router-link>
            <!--
            <button id="disable">任務攻略</button>
            <button id="disable">獎勵兌換</button>
            -->
            <button id="disable" onclick="location.href='https://tcto.me/RVAGC'" >會員條碼</button>
            <button id="disable" @click="getQRCodeContent">ScanQR</button>
          </div>
        </div>
      </div>

      <!-- blank -->
      <div class="w3-container">
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'markMGMHome',
  methods: {
    // 當推薦者觸發推薦好友的LIFF時 //
    recommend: function() {
      this.$store.dispatch('recommend', 
      {
        c: this.channelId
      })
      // 防止重複點擊按鈕 //
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 2000)
    },
    numOfshare: function() {
      this.$store.dispatch('numOfshare', 
      {
        c: this.channelId
      })
    },
    getQRCodeContent:function(){
      this.$store.dispatch('getQRCodeContent', this.liffId)
    }
  
  },
  computed: {
    ...mapGetters({
      channelId: 'channelId'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    ...mapGetters({
      point: 'point'
    }),
    ...mapGetters({
      level: 'level'
    }),
    ...mapGetters({
      share: 'share'
    }),
    ...mapGetters({
      displayname: 'displayname'
    }),
    ...mapGetters({
      picture: 'picture',
      liffId:'_liffId'
    })
  },
  mounted() {
    document.body.style.backgroundColor="#0A0201"
    this.numOfshare()
  }
}
</script>

<style scoped>
@import url("https://www.w3schools.com/w3css/4/w3.css");
p {
  color: white;
  font-size: 18px;
  padding: 5px;
  text-align: left;   
  line-height: 8px; 
}
#pic {
  border-radius: 50%;
  margin-top: 10px;
  margin-left: 10px;
}
#userName {
  white-space: nowrap;
}
#lv {
  white-space: nowrap;
}
#btn {
  margin-top: 35px;
}
button {
  float: right;
  /*background-color: #367CC0;*/
  color: white;
  font-weight: bolder;
  font-family: "微軟正黑體";
  width: 70%;
  padding: 9px 10px;
  margin-bottom: 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 17px;
  border: 1px white solid;
  border-radius: 10px;
}
#able {
  background-color: #B51700;
}
#disable {
  background-color: #929292;
}
img {
  width: 61%;
}
#medal {
  width: 26%;
  margin-left: 10px;
}
#logo {
  margin-top: 14px;
  width: 45%;
}
</style>


// WEBPACK FOOTER //
// src/components/markMGMHome.vue